// extracted by mini-css-extract-plugin
export default {"title":"HowItWorks-module__title--rJhNg","hiwSteps":"HowItWorks-module__hiwSteps--UPr3Z"};